var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature6Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83706 4.77335C4.89933 4.7318 7.68945 3.56344 9.8116 1.66406C11.9337 3.56344 14.7239 4.7318 17.7861 4.77335C17.8973 5.43581 17.9552 6.11634 17.9552 6.8104C17.9552 12.1291 14.556 16.6538 9.8116 18.3307C5.06715 16.6538 1.66797 12.1291 1.66797 6.8104C1.66797 6.11635 1.72585 5.43581 1.83706 4.77335ZM13.5853 8.54813C13.9828 8.15059 13.9828 7.50606 13.5853 7.10852C13.1877 6.71099 12.5432 6.71099 12.1457 7.10852L8.79364 10.4605L7.47754 9.14443C7.08 8.7469 6.43547 8.7469 6.03794 9.14443C5.6404 9.54197 5.6404 10.1865 6.03794 10.584L8.07384 12.6199C8.47138 13.0175 9.11591 13.0175 9.51345 12.6199L13.5853 8.54813Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6Icon);
export default __webpack_public_path__ + "static/media/feature-6-icon.db7b7cb651a35f6bb4de997f1c27bf03.svg";
export { ForwardRef as ReactComponent };